<template>
  <vue-select
    label="code"
    id="select-border"
    :getOptionLabel="getOptionLabel"
    v-model="selected"
    :filterable="false"
    :filter=filter
    :options="options"
    @search="handleKeywords"
    @change="handleChange"
    :clearable="false"
    :placeholder="placeholder">
    <template slot="option" slot-scope="option">
      <slot name="selected-option airline-option" v-bind="(typeof option === 'object')?option:{[label]: option}">
        <div class="option-wrapper">
          <img class="airline-logo" :src="`/img/aircorp/${option.code.toLowerCase()}.png`" height="16px" width="16px">
<!--          <div  class="logo-wrapper" :style="`background: url('/img/aircorp/${option.code.toLowerCase()}.png'); background-size: contain;height: 16px; width: 16px; margin-right: 4px;`"></div>-->
          {{ getOptionLabel(option) }}
        </div>
      </slot>
    </template>
    <div slot="no-options">{{ $t('Please write airline code') }}</div>
  </vue-select>
</template>

<script>
import VueSelect from 'vue-select'
import _ from 'lodash'
import { searchKeyword } from '../util'

export default {
  name: 'AirlineSelector',
  components: {
    VueSelect
  },
  props: {
    placeholder: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      selected: null,
      airlines: [],
      options: [],
      filter (options, search) {
        this.$emit('keywords', search)
      }
    }
  },
  mounted () {
    let url = '/airlines.json'
    this.$http.get(url).then(resposne => {
      this.airlines = resposne.data.filter(d => d.code && d.airline).sort((a, b) => (a.code > b.code) ? 1 : -1)
    })
  },
  methods: {
    getOptionLabel (option) {
      return option['code'] + '--' + option['airline']
    },
    handleChange (option) {
      this.$emit('selected', option)
    },
    handleKeywords (search) {
      this.keywords = search
      this.debouncedKeywords()
    },
    debouncedKeywords: _.debounce(function () {
      this.search()
    }, 200),
    search () {
      this.options = searchKeyword(this.airlines, this.keywords, 'airline')
    }
  }
}
</script>

<style scoped lang="scss">
  #select-border  {
    height: 57px;
    display: flex;
    align-items: center;
    padding: 0;
  }
  .airline-logo {
    position: relative;
    &:before {
      content: "";
      display: block;
      position: absolute;
      background: white;
      top: 0;
      bottom: 0;
      min-height: 16px;
      min-width:  16px;
    }
  }
</style>
